import { api } from '../api.ts';
import { useGame, money, ago, duration, fmt } from '../state.tsx';
import { Panel, EventText, Loading, useLoad, go, FeedLine } from '../components/ui.tsx';
import { DailyPanel, AwayStory } from '../components/daily.tsx';

export function HomePage() {
  const { me, away, dismissAway, act } = useGame();
  // Refresh the feeds every 30 seconds, and whenever your stats change.
  const { data, reload } = useLoad(() => api.get('/api/feed'), [me?.fightsWon, me?.level], 30_000);
  if (!me) return <Loading />;
  return (
    <div>
      {away && (
        <div className="welcome-back">
          <h3>Welcome back. You were away for {duration(away.awayMs)}.</h3>
          {away.story && away.awayMs >= 3_600_000 && <AwayStory text={away.story} />}
          <ul style={{ margin: '4px 0', paddingLeft: 18 }}>
            {away.attacksReceived > 0 ? (
              <li>You were attacked <b>{away.attacksReceived}</b> time(s): you fought off {away.attacksWon}
                {away.cashLost > 0 && <> and lost <span className="bad">{money(away.cashLost)}</span></>}
                {away.cashWon > 0 && <>, taking <span className="money">{money(away.cashWon)}</span> from attackers</>}.
                {away.cashLost > 0 && <> <a onClick={() => go('bank')}>Bank your cash</a> to keep it safe.</>}
              </li>
            ) : <li>Nobody attacked you while you were gone.</li>}
            {away.incomeWaiting > 0 && <li>Your properties earned <span className="money">{money(away.incomeWaiting)}</span>. <a onClick={() => go('territory')}>Collect it</a>.</li>}
            {away.invites > 0 && <li>You have <b>{away.invites}</b> new mafia invitation(s). <a onClick={() => go('mafia')}>See them</a>.</li>}
            {away.newMembers > 0 && <li><b>{away.newMembers}</b> new member(s) joined your mafia.</li>}
            {me.giftsReady > 0 && <li>You can send <b>{me.giftsReady}</b> daily gift(s) to your mafia. <a onClick={() => go('mafia')}>Send gifts</a>.</li>}
            <li>Your energy is back to <b>{away.energy}/{away.maxEnergy}</b>. <a onClick={() => go('jobs')}>Do some jobs</a>.</li>
          </ul>
          <a className="small" onClick={dismissAway}>Dismiss</a>
        </div>
      )}
      {me.bountyOnMe > 0 && <div className="flash bad"><div>☠ Someone put a <b>{money(me.bountyOnMe)}</b> bounty on your head. Anyone can hunt you from the <a href="#/fight/hitlist">Hitlist</a> until you’re taken out, so keep your health up.</div></div>}
      <div className="row">
        <div className="grow">
          <Panel title="Your Updates" right={<a className="small" onClick={reload}>Refresh</a>}>
            {!data ? <Loading /> : data.updates.length === 0 ? <div className="muted">Nothing yet. Go do some jobs!</div> : data.updates.map((e: any) => <FeedLine key={e.id} e={e} when={ago(e.createdAt)} />)}
          </Panel>
        </div>
        <div style={{ width: 300 }}>
          {me.streak && <DailyPanel />}
          <Panel title="Your Family Business">
            <div className="stat-grid" style={{ gridTemplateColumns: '1fr' }}>
              <div><span>Mafia size</span><b>{me.mafiaSize}</b></div>
              <div><span>Fighters with gear</span><b>{me.fighters}</b></div>
              <div><span>Attack strength</span><b>{fmt(me.attackStrength)}</b></div>
              <div><span>Defense strength</span><b>{fmt(me.defenseStrength)}</b></div>
              <div><span>Income per hour</span><span className="money">{money(me.hourlyIncome)}</span></div>
              <div><span>Waiting to collect</span><span className="money">{money(me.pendingIncome)}</span></div>
              <div><span>Jobs done</span><b>{fmt(me.jobsDone)}</b></div>
              <div><span>Fights won / lost</span><b>{fmt(me.fightsWon)} / {fmt(me.fightsLost)}</b></div>
              <div><span>Favor points</span><b className="gold">{me.favorPoints}</b></div>
            </div>
            {me.pendingIncome > 0 && (
              <div style={{ marginTop: 8 }}>
                <button className="btn green" onClick={() => act('/api/properties/collect', {}, { success: (r) => ({ kind: 'good', text: <>You collected <span className="money">{money(r.amount)}</span> from your properties.</> }) })}>Collect income</button>
              </div>
            )}
          </Panel>
          {me.giftsReady > 0 && (
            <div className="flash good" style={{ marginBottom: 10 }}>
              <div>You have <b>{me.giftsReady}</b> daily gift(s) to send. <a onClick={() => go('mafia')}>Send them</a></div>
            </div>
          )}
          <Panel title="Mafia News" right={<span className="small dim">updates automatically</span>}>
            {!data ? <Loading /> : data.news.slice(0, 14).map((e: any) => (
              <div key={e.id} className="feed-item">
                <span className={`feed-dot ${e.kind}`} />
                <div className="grow"><EventText e={e} /></div>
                <span className="when">{ago(e.createdAt)}</span>
              </div>
            ))}
          </Panel>
        </div>
      </div>
    </div>
  );
}
